import Loadable from '@loadable/component';
const Chart = Loadable(() => import('react-apexcharts'));

export { default as useChart } from './useChart';

export default Chart;
